import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "components/navbar";
import Sidebar from "components/sidebar";
import Footer from "components/footer/Footer";
import routes from "routes.js";

// --- YENİ İMPORTLAR (Firebase, Auth ve API) ---
import { useAuth } from "context/AuthContext";
import {
  requestPermissionAndGetToken,
  checkAndRefreshFcmToken,
} from "firebase-helper";
import { onMessage } from "firebase/messaging";
import { messaging } from "firebase-config";
import { usersAPI } from "services/api";

export default function Vault(props) {
  const { ...rest } = props;
  const location = useLocation();
  const [open, setOpen] = React.useState(true);
  const [currentRoute, setCurrentRoute] = React.useState("Main Dashboard");

  // --- AUTH CONTEXT ---
  const { user } = useAuth();

  React.useEffect(() => {
    window.addEventListener("resize", () =>
      window.innerWidth < 1200 ? setOpen(false) : setOpen(true)
    );
  }, []);
  React.useEffect(() => {
    getActiveRoute(routes);
  }, [location.pathname]);

  // --- 1. FCM İZİN İSTEĞİ VE ANLIK DİNLEME (CORE-UI MANTIĞI) ---
  React.useEffect(() => {
    let unsubscribe = () => {};

    if (user && user.role) {
      // PWA KONTROLÜ: Adam uygulamayı ana ekrana eklemiş mi?
      const isPWA =
        window.matchMedia("(display-mode: standalone)").matches ||
        window.navigator.standalone === true;

      // Token'ı backend'e kaydetmek için yardımcı fonksiyon
      const saveTokenToBackend = async (token) => {
        if (token) {
          try {
            await usersAPI.storeFcmToken(token, navigator.userAgent);
            console.log(
              "PWA (Vault): FCM Token başarıyla backend'e kaydedildi."
            );
          } catch (e) {
            console.warn("PWA (Vault): FCM Token kaydedilemedi:", e.message);
          }
        }
      };

      // Eğer PWA ise ve henüz izin istememişsek (default), orijinal pop-up'ı fırlat!
      if (
        isPWA &&
        "Notification" in window &&
        Notification.permission === "default"
      ) {
        console.log("PWA algılandı, orijinal bildirim izni isteniyor...");
        requestPermissionAndGetToken().then(saveTokenToBackend);
      }
      // Veya zaten daha önceden izin vermişse (granted), sessizce token al ve backend'i güncelle
      else if (
        "Notification" in window &&
        Notification.permission === "granted"
      ) {
        requestPermissionAndGetToken().then(saveTokenToBackend);
      }

      // Uygulama AÇIKKEN (foreground) gelen bildirimleri dinle ve ekranda göster
      unsubscribe = onMessage(messaging, (payload) => {
        console.log("Uygulama açıkken bildirim alındı: ", payload);
        if (payload.notification && "serviceWorker" in navigator) {
          navigator.serviceWorker.ready.then((registration) => {
            registration.showNotification(payload.notification.title, {
              body: payload.notification.body,
              icon: payload.notification.icon || "/192.png",
              data: { url: payload.fcmOptions?.link },
            });
          });
        }
      });
    }

    return () => unsubscribe();
  }, [user]);

  // --- 2. SESSİZ TOKEN YENİLEME (Uygulama arka plandan öne gelince) ---
  React.useEffect(() => {
    const handleVisibilityChange = async () => {
      if (document.visibilityState === "visible") {
        const token = await checkAndRefreshFcmToken();
        if (token) {
          try {
            await usersAPI.storeFcmToken(token, navigator.userAgent);
          } catch (e) {
            console.warn("Visibility Token kaydedilemedi:", e.message);
          }
        }
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () =>
      document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, []);

  const getActiveRoute = (routes) => {
    let activeRoute = "Main Dashboard";
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(
          routes[i].layout + "/" + routes[i].path
        ) !== -1
      ) {
        setCurrentRoute(routes[i].name);
      }
    }
    return activeRoute;
  };
  const getActiveNavbar = (routes) => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
      ) {
        return routes[i].secondary;
      }
    }
    return activeNavbar;
  };
  // layouts/admin/index.jsx (ve diğer layoutlar) içindeki getRoutes
  const getRoutes = (routes) => {
    let allRoutes = [];

    routes.forEach((prop, key) => {
      // 1. Eğer elemanın direkt bir componenti varsa kaydet
      if (prop.layout === "/vault" && prop.component) {
        allRoutes.push(
          <Route path={prop.path} element={prop.component} key={key} />
        );
      }

      // 2. EĞER ELEMANIN ALT ÖĞELERİ (items) VARSA ONLARI DA KAYDET (Boş sayfa hatasını bu çözer)
      if (prop.items) {
        prop.items.forEach((item, itemKey) => {
          // Alt öğe bu layout'a mı ait? (Genelde evet)
          allRoutes.push(
            <Route
              path={item.path}
              element={item.component}
              key={`${key}-${itemKey}`}
            />
          );
        });
      }
    });

    return allRoutes;
  };

  document.documentElement.dir = "ltr";
  return (
    <div className="flex h-full w-full">
      <Sidebar open={open} onClose={() => setOpen(false)} />
      {/* Navbar & Main Content */}
      <div className="h-full w-full bg-lightPrimary dark:!bg-navy-900">
        {/* Main Content */}
        <main
          className={`mx-[12px] h-full flex-none transition-all md:pr-2 xl:ml-[313px]`}
        >
          {/* Routes */}
          <div className="h-full">
            <Navbar
              onOpenSidenav={() => setOpen(true)}
              // Dinamik işletme ismi
              logoText={user?.business_name || "RandevUpp"}
              brandText={currentRoute}
              secondary={getActiveNavbar(routes)}
              {...rest}
            />
            <div className="pt-5s mx-auto mb-auto h-full min-h-[84vh] p-2 md:pr-2">
              <Routes>
                {getRoutes(routes)}

                <Route
                  path="/"
                  element={<Navigate to="/vault/dashboard" replace />}
                />
              </Routes>
            </div>
            <div className="p-3">
              <Footer />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
